<template>
    <v-row>
        <v-col cols="12">
            <p class="text-left mt-4 mb-0">{{ $t('page.series.race-column.description-1')}}</p>
            <p class="text-left mb-0">{{ $t('page.series.race-column.description-2')}}</p>
            <p class="text-left">{{ $t('page.series.race-column.description-3')}}</p>
        </v-col>
        <v-col cols="12">
            <v-data-table 
                :headers="headers" 
                :items="rows" 
                class="elevation-1 ma-0 tableCust"
                :footer-props="{
                    'items-per-page-text': $t('dataTable.rowsPerPageText'),
                    'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                }"
                :no-data-text="$t('dataTable.noDataText')"
                :headerProps="{
                    'sort-by-text': $t('dataTable.sortByText')
                }"
            >
                <template v-slot:item.columnFirstLine="{ item: {texts} }">
                    <span v-if="texts.en && texts.en.labelFirstLine">
                        {{$t('page.series.race-column.ab_en')}}: {{ texts.en.labelFirstLine }}
                    </span><br v-if="texts.en && texts.en.labelFirstLine" />
                    <span v-if="texts.fr && texts.fr.labelFirstLine">
                        {{$t('page.series.race-column.ab_fr')}}: {{ texts.fr.labelFirstLine }}
                    </span><br v-if="texts.fr && texts.fr.labelFirstLine" />
                    <span v-if="texts.es && texts.es.labelFirstLine">
                        {{$t('page.series.race-column.ab_es')}}: {{ texts.es.labelFirstLine }}
                    </span>
                </template>
                <template v-slot:item.columnSecondLine="{ item: {texts} }">
                    <span v-if="texts.en && texts.en.labelSecondLine">
                        {{$t('page.series.race-column.ab_en')}}: {{ texts.en.labelSecondLine }}
                    </span><br v-if="texts.en && texts.en.labelSecondLine" />
                    <span v-if="texts.fr && texts.fr.labelSecondLine">
                        {{$t('page.series.race-column.ab_fr')}}: {{ texts.fr.labelSecondLine }}
                    </span><br v-if="texts.fr && texts.fr.labelSecondLine" />
                    <span v-if="texts.es && texts.es.labelSecondLine">
                        {{$t('page.series.race-column.ab_es')}}: {{ texts.es.labelSecondLine }}
                    </span>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                </template>
            </v-data-table>
        </v-col>
                        <v-dialog v-model="dialog" max-width="600px" >
                            <v-card>
                                <v-card-title>{{ $t('page.series.race-column.title') }}</v-card-title>
                                <v-card-text>
                                    <v-form ref="form" class="pt-4 inputSeries">
                                        <div>
                                            <span class="labelCard text-h6">{{ $t('common.english') }}</span>
                                            <v-card outlined>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="12" class="mt-2">
                                                            <v-text-field 
                                                                outlined dense 
                                                                :label="$t('page.series.race-column.race-column-label-first-line')" 
                                                                v-model="raceColumnLFLE"
                                                                :rules="[
                                                                    (v) => $inputRules({value: v, minSize: 0, maxSize: 70}, 'fieldLength') || $t('page.series.race-column.race-column-error-first-line')
                                                                ]"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field 
                                                                outlined dense 
                                                                :label="$t('page.series.race-column.race-column-label-second-line')" 
                                                                v-model="raceColumnLSLE"
                                                                :rules="[
                                                                    (v) => $inputRules({value: v, minSize: 0, maxSize: 70}, 'fieldLength') || $t('page.series.race-column.race-column-error-second-line')
                                                                ]"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </div>
                                        <div class="mt-4">
                                            <span class="labelCard text-h6">{{ $t('common.french') }}</span>
                                            <v-card outlined>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="12" class="mt-2">
                                                            <v-text-field 
                                                                outlined dense 
                                                                :label="$t('page.series.race-column.race-column-label-first-line')" 
                                                                v-model="raceColumnLFLF"
                                                                :rules="[
                                                                    (v) => $inputRules({value: v, minSize: 0, maxSize: 70}, 'fieldLength') || $t('page.series.race-column.race-column-error-first-line')
                                                                ]"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field 
                                                                outlined dense 
                                                                :label="$t('page.series.race-column.race-column-label-second-line')" 
                                                                v-model="raceColumnLSLF"
                                                                :rules="[
                                                                    (v) => $inputRules({value: v, minSize: 0, maxSize: 70}, 'fieldLength') || $t('page.series.race-column.race-column-error-second-line')
                                                                ]"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </div>
                                        <div class="mt-4">
                                            <span class="labelCard text-h6">{{ $t('common.spanish') }}</span>
                                            <v-card outlined>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="12" class="mt-2">
                                                            <v-text-field 
                                                                outlined dense 
                                                                :label="$t('page.series.race-column.race-column-label-first-line')" 
                                                                v-model="raceColumnLFLES"
                                                                :rules="[
                                                                    (v) => $inputRules({value: v, minSize: 0, maxSize: 70}, 'fieldLength') || $t('page.series.race-column.race-column-error-first-line')
                                                                ]"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field 
                                                                outlined dense 
                                                                :label="$t('page.series.race-column.race-column-label-second-line')" 
                                                                v-model="raceColumnLSLES"
                                                                :rules="[
                                                                    (v) => $inputRules({value: v, minSize: 0, maxSize: 70}, 'fieldLength') || $t('page.series.race-column.race-column-error-second-line')
                                                                ]"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </div>
                                        
                                    </v-form>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                    <v-btn dark color="primary darken-2" small @click="close">{{ $t('common.form.cancel') }}</v-btn>
                    <v-btn dark color="primary darken-2" small @click="save">{{ $t('common.form.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
        <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
    </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
  name: 'SeriesRaceColumnTbl',
  mixins: [apiCalls],
  components: { SGSNotificationAlert },
  props: {},
  data() {
    return {
        rows: [],
        dialog: false,
        raceColumnLFLE: '',
        raceColumnLFLF: '',
        raceColumnLFLES: '',
        raceColumnLSLE: '',
        raceColumnLSLF: '',
        raceColumnLSLES: '',
        itemSelected: null,
        dialogAlert:  false,
        alertMessage: '',

    };
  },
  computed: {
    headers() {
        return [
            {
                text: this.$t('page.series.table.race.race-id'),
                value: "id" 
            },
            {
                text: this.$t('page.series.table.race.event-race-name'),
                value: "eventRaceName" 
            },
            {
                text: this.$t('page.series.table.race.column-label-first-line'),
                value: "columnFirstLine"
            },
            {
                text: this.$t('page.series.table.race.column-label-second-line'),
                value: "columnSecondLine"
            },
            {
                text: this.$t('common.actions'),
                value: "actions"
            }
        ];
    },
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
  },
  methods: {
    async init() {
        if(this.seriesSelected) {
            const response = await this.api('get', `/api/v1/promoter/series/raceHeaders/${this.seriesSelected.id}`);
            
            if(Array.isArray(response) && response.length > 0) {
                this.rows = response.map((el) => {
                    return {
                        ...el,
                        eventRaceName: `${this.$escapeHtml.decode(el.eventName)} - ${this.$escapeHtml.decode(el.raceName)}`
                    };
                });
            }
        } else {
            this.rows = [];
        }
    },
    editItem(item) {
        this.itemSelected = item;
        this.raceColumnLFLE = item.texts.en ? item.texts.en.labelFirstLine : '';
        this.raceColumnLFLF = item.texts.fr ? item.texts.fr.labelFirstLine : '';
        this.raceColumnLFLES = item.texts.es ? item.texts.es.labelFirstLine : '';
        this.raceColumnLSLE = item.texts.en ? item.texts.en.labelSecondLine : '';
        this.raceColumnLSLF = item.texts.fr ? item.texts.fr.labelSecondLine : '';
        this.raceColumnLSLES = item.texts.es ? item.texts.es.labelSecondLine : '';
        this.dialog = true;
    },
    close() {
        this.dialog = false;
    },
    async save() {
        if(this.itemSelected) {
            
            let data = {
                seriesRaceId: this.itemSelected.id,
                seriesId: this.seriesSelected.id,
                texts: {
                    en: { labelFirstLine: this.raceColumnLFLE, labelSecondLine: this.raceColumnLSLE },
                    fr: { labelFirstLine: this.raceColumnLFLF, labelSecondLine: this.raceColumnLSLF },
                    es: { labelFirstLine: this.raceColumnLFLES, labelSecondLine: this.raceColumnLSLES }
                }
            };
            
            const response = await this.api('post', '/api/v1/promoter/series/raceHeader', data);
            
            if (response != undefined) {
                if(response && !response.error) {
                    this.dialog = false;
                    this.init();
                } else if(response.error) {
                    this.reopenEdition = true;
                    if(response && response.error && Array.isArray(response.error) && response.error.length > 0) {
                        this.dialog = false;
                        this.dialogAlert =  true;
                        this.alertMessage = this.$t('page.series.'+response.error[0]);
                    } else if(response.error && typeof response.error == 'string') {
                        this.dialog = false;
                        this.dialogAlert =  true;
                        this.alertMessage = this.$t('page.series.'+response.error);
                    } else {
                        this.dialog = false;
                        this.dialogAlert =  true;
                        this.alertMessage = this.$t('common.failed-save');
                    }
                } else {
                    this.reopenEdition = true;
                    this.dialog = false;
                    this.dialogAlert = true;
                    this.alertMessage = this.$t('page.series.error_general');  
                }
            } else {
                this.reopenEdition = true;
                this.dialog = false;
                this.dialogAlert = true;
                this.alertMessage = this.$t('page.series.error_general');
            }
        }
    },
    closeAlert() {
      this.dialogAlert = false;
      if(this.reopenEdition){
        this.dialog = true;
      }
    }
  },
  watch: {
    seriesSelected(val) {
        if(val) {
            this.init();
        }
    }
  }
}
</script>

<style>
.labelCard {
    margin: -16px 100% 0px 20px;
    padding: 0 5px;
    position: absolute;
    z-index: 1000;
    display: block;
    background-color: white;
}
</style>